import { useAdminUsers } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { Alert, Badge, Table, TBody, Td, Th, THead, Tr } from '@numistic/ui'
import { createRoute } from '@tanstack/react-router'

import { useErrorText } from '../../lib/errors.js'
import { formatDate } from '../../lib/format.js'
import { adminRoute } from './layout.js'

export const adminUsersRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/users',
  component: AdminUsersPage,
})

function AdminUsersPage() {
  const { t } = useTranslation()
  const errorText = useErrorText()
  const users = useAdminUsers()
  if (users.error) return <Alert variant="destructive">{errorText.request(users.error)}</Alert>
  return (
    <Table>
      <THead>
        <Tr>
          <Th>{t('admin.columns.name')}</Th>
          <Th>{t('admin.columns.email')}</Th>
          <Th>{t('admin.columns.role')}</Th>
          <Th>{t('admin.columns.created')}</Th>
        </Tr>
      </THead>
      <TBody>
        {users.data?.map((u) => (
          <Tr key={u.id}>
            <Td className="font-medium">{u.name}</Td>
            <Td>{u.email}</Td>
            <Td>
              <Badge variant={u.role === 'admin' ? 'primary' : 'default'}>
                {t(`roles.${u.role}`)}
              </Badge>
            </Td>
            <Td className="text-muted-foreground">{formatDate(u.createdAt)}</Td>
          </Tr>
        ))}
      </TBody>
    </Table>
  )
}
